var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mianzheng"},[_c('img',{attrs:{"src":require("../../assets/img/2_02.png")}}),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.time)+" s")])])}
var staticRenderFns = []

export { render, staticRenderFns }